import StarterKit from "@tiptap/starter-kit";
import { TextStyle, FontSize, Color } from "@tiptap/extension-text-style";
import { Highlight } from "@tiptap/extension-highlight";
import { TextAlign } from "@tiptap/extension-text-align";
import type { Extensions } from "@tiptap/react";
import { LineHeight } from "./lineHeight";

// Shared schema for the text-widget editor. StarterKit provides paragraphs,
// bold, italic, underline, lists and undo/redo; the rest add font size, text
// color, highlight (multicolor), text alignment and line spacing.
export const textWidgetExtensions: Extensions = [
  StarterKit,
  TextStyle,
  FontSize,
  Color,
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ["heading", "paragraph"] }),
  LineHeight.configure({ types: ["heading", "paragraph"] }),
];
